import { GetSupplierItemRes, SearchCondition, SupplierSearchResponse } from '@gateway.maintenance'
import { yamadumiApi } from '../yamadumi-api'
/**
 * 業者マスタメンテナンス-明細取得のゲートウェイクラス
 */
export class SupplierListGateway {
  /**
   * 業者マスタメンテナンス-明細取得
   */
  static fetchSupplierSearchList = async (params?: SearchCondition) => {
    return await yamadumiApi.get<SupplierSearchResponse>(
      '/api/maintenance/supplier/list',
      { ...params }
    )
  }

  /**
   * @param supplierCd 業者コード
   * 業者マスタメンテナンス-詳細取得
   */
  static GetSupplierItem = async (supplierCd: string, supplierBranchCd: string) => {
    return await yamadumiApi.get<GetSupplierItemRes>(
      '/api/maintenance/supplier/item',
      { supplierCd, supplierBranchCd }
    )
  }
}
